import { LoadingIndicator } from "@indietabletop/appkit";
import * as css from "./style.css.ts";

export function LoadingView() {
  return (
    <div className={css.root}>
      <LoadingIndicator />
    </div>
  );
}
